export function NotFound() {
  return <p>Crap wrong way :X</p>;
}
